import { useCallback } from 'react';

interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export const useToast = () => {
  const toast = useCallback((options: ToastOptions) => {
    console.log('Toast:', options);
    // This would typically integrate with a toast library
  }, []);

  return { toast };
};

export const toast = (options: ToastOptions) => {
  console.log('Toast:', options);
  // This would typically integrate with a toast library
};
